/* eslint-disable import/first */

//region 1. Platform Libraries
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../status', () => {
    const dataAPI = new DataAPI();

    before(function before(done) {
        this.timeout(3000);
        dataAPI.initialize({
            environment: 'unit-test',
            heartbeatInterval: 10,
            logLevel: 'ERROR',
            mongoUrl: process.env.CLIO_MONGO_URL,
            port: 15925,
        });
        dataAPI.start(done);
    });

    describe('PUT', () => {
        it('should create new event status', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/status')
                .send({
                    recorderId: '123456789a123456789b123a',
                    module: 'broker',
                    status: 'activated',
                })
                .expect(200)
                .end(/** @type function */done);
        });

        it('should fail if no required properties', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/status')
                .send({
                    recorderId: '123456789a123456789b123a',
                    module: 'broker',
                })
                .expect(400)
                .end(/** @type function */done);
        });

        it('should fail if no body', (done) => {
            request(dataAPI.expressApp)
                .put('/cameras/123456789a123456789b1234/streams/0/status')
                .expect(400)
                .end(/** @type function */done);
        });
    });

    after(done => dataAPI.stop(done));
});
